import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_generic_doc_ctrl_acc_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_doc_hdr: fromDatatype.GuidDataFieldInterface;
  guid_doc_line: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  option: fromDatatype.VarcharDatatypeInterface;
  logic: fromDatatype.VarcharDatatypeInterface;
  date_start: fromDatatype.TimestampTzDatatypeInterface;
  date_end: fromDatatype.TimestampTzDatatypeInterface;
  net_amount_debit: fromDatatype.MoneyDatatypeInterface;
  net_amount_credit: fromDatatype.MoneyDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_generic_doc_ctrl_acc_RowClass
  implements bl_fi_generic_doc_ctrl_acc_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_doc_hdr: fromDatatype.GuidDataFieldInterface;
  guid_doc_line: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  option: fromDatatype.VarcharDatatypeInterface;
  logic: fromDatatype.VarcharDatatypeInterface;
  date_start: fromDatatype.TimestampTzDatatypeInterface;
  date_end: fromDatatype.TimestampTzDatatypeInterface;
  net_amount_debit: fromDatatype.MoneyDatatypeInterface;
  net_amount_credit: fromDatatype.MoneyDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
